import React from 'react'
import Header from './Header'
import Hero from './Hero'
import About from './About'
import Features from './Features'
import HowItsWork from './HowItsWork'
import Intro from './Intro'
import Carosule from './Carosule'
import Faq from './Faq'
import Contact from './Contact'
import Footer from './Footer'
import Roadmap from './Roadmap'

const Landing = () => {
  return (
    <div >
       <div className="main-hero" id="home">
        <Header />
        <Hero />
      </div>
      <About />
      <div className="f-bg">
        <Features />
        <HowItsWork />
      </div>
      <Intro />
      <Carosule />
      <Roadmap />
      <div style={{ position: "relative" }}>
        <Faq />
        {/* <Contact /> */}
        <Footer />
      </div>
    </div>
  )
}

export default Landing
